import { Injectable } from "@angular/core";
import { BalanceData } from "../types/balance-data.type";
import { BehaviorSubject } from "rxjs";
import { RiskExposureService, Bet as RiskBet } from "./risk-exposure.service";
import { Bet, CalculationBet, MarketProvider } from "../types/bet.type";
import { BetService } from "./bet.service";
import { ExposureHelperService } from "./exposure-helper.service";

@Injectable({
  providedIn: "root",
})
export class ExposureService {
  currentMarketExposures: Record<string, number[]> = {}; // Hold market exposures based on market id(i.e. the key of the object is market ID).
  predictedMarketExposure: Record<string, number> = {}; // Hold market exposures based on selection id(i.e. the key of the object is selection ID).
  private balanceData$: BehaviorSubject<BalanceData | null> = new BehaviorSubject<BalanceData | null>(null); // Makes the balance data available for the whole application

  constructor(private exposureHelperService: ExposureHelperService) {}

  set setBalance(balanceData: BalanceData) {
    this.balanceData$.next(balanceData);
  }

  get balanceData() {
    return this.balanceData$;
  }

  clearCurrentMarketExposures() {
    this.predictedMarketExposure = {};
  }

  clearPredictedMarketExposure() {
    this.predictedMarketExposure = {};
  }
}
